var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 41.8595H28L19.1 47.7794C17.78 48.6594 16 47.7195 16 46.1195V41.8595C10 41.8595 6 37.8595 6 31.8595V19.8594C6 13.8594 10 9.85938 16 9.85938H36C42 9.85938 46 13.8594 46 19.8594V31.8595C46 37.8595 42 41.8595 36 41.8595Z",
    stroke: "#727272",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9996 27.7188V27.2988C25.9996 25.9388 26.8397 25.2188 27.6797 24.6388C28.4997 24.0788 29.3196 23.3588 29.3196 22.0388C29.3196 20.1988 27.8396 18.7188 25.9996 18.7188C24.1596 18.7188 22.6797 20.1988 22.6797 22.0388",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.991 32.5H26.009",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/Request.7e6fe1e0658c23df313b81488d994007.svg";
export { ForwardRef as ReactComponent };